/*@ngInject*/
const CheckClearanceRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.checkClearance = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/checkClearance';
        return this.get(url);
    };
};
angular.module('gw-um-submission').service('checkClearanceRepository', CheckClearanceRepository);
